export default class BaseApplication
{
	start(){}
	end(){}
	update(){}
	on_post_render(){}
	on_pre_render(){}
}